import TableRowMoveDownIcon from '@atlaskit/icon/core/table-row-move-down';
import TableRowMoveUpIcon from '@atlaskit/icon/core/table-row-move-up';
import { SHORTCUTS } from '@databases/keyboard-shortcuts';
import React from 'react';
import { useIntl } from 'react-intl-next';

import { type Trigger, type Action, ActionPopup } from '../ActionPopup';
import { type PositionType } from '../actions/entries/select-entries-actions';
import { messages } from '../messages';

type MoveEntriesTypes = {
  handleMoveEntries: (position: PositionType) => void;
  canMoveUp: boolean;
  canMoveDown: boolean;
  selectedEntriesCount: number;
};

export const MoveEntries = ({
  handleMoveEntries,
  canMoveUp,
  canMoveDown,
  selectedEntriesCount
}: MoveEntriesTypes) => {
  const { formatMessage } = useIntl();

  const isMultiSelected = selectedEntriesCount > 1;
  const moveUpActionMessage = isMultiSelected
    ? formatMessage(messages['action-bar.multiple-entries-move-up-action'])
    : formatMessage(messages['action-bar.single-entry-move-entry-up-action']);
  const moveDownActionMessage = isMultiSelected
    ? formatMessage(messages['action-bar.multiple-entries-move-down-action'])
    : formatMessage(messages['action-bar.single-entry-move-entry-down-action']);

  const actions: Action[] = [
    {
      type: 'move-up',
      message: moveUpActionMessage,
      icon: <TableRowMoveUpIcon label={moveUpActionMessage} size="medium" />,
      onClick: () => handleMoveEntries('before'),
      shouldRender: canMoveUp,
      shortcut: SHORTCUTS.MOVE_ENTRIES_UP
    },
    {
      type: 'move-down',
      message: moveDownActionMessage,
      icon: <TableRowMoveDownIcon label={moveDownActionMessage} size="medium" />,
      onClick: () => handleMoveEntries('after'),
      shouldRender: canMoveDown,
      shortcut: SHORTCUTS.MOVE_ENTRIES_DOWN
    }
  ];

  const trigger: Trigger = {
    type: 'move',
    message: formatMessage(messages['action-bar.single-entry-move-button']),
    icon: (
      <TableRowMoveDownIcon
        label={formatMessage(messages['action-bar.single-entry-move-button'])}
        size="medium"
      />
    ),
    selectionMode: 'entry'
  };

  return <ActionPopup actions={actions} trigger={trigger} />;
};
